import {Component, OnInit, OnDestroy} from '@angular/core';
import {DataService} from '../../services/data.service';

@Component({
  selector: 'app-comments',
  templateUrl: './comments.component.html',
  styleUrls: ['./comments.component.scss']
})
export class CommentsComponent implements OnInit, OnDestroy {
  commentsVisible: boolean;

  constructor(private data: DataService) {
  }

  ngOnInit() {
    this.data.currentComments.subscribe(comments => this.commentsVisible = comments);
    // tslint:disable-next-line: only-arrow-functions
    // (function(d, s, id) {
    //   let js;
    //   const fjs = d.getElementsByTagName(s)[0];
    //   js = d.createElement(s);
    //   js.id = id;
    //   js.src = '//connect.facebook.net/bg_BG/sdk.js#xfbml=1&version=v2.8&appId=344660855936579';
    //   fjs.parentNode.insertBefore(js, fjs);
    // }(document, 'script', 'facebook-jssdk'));
  }

  ngOnDestroy(): void {
    // document.getElementById('facebook-jssdk').remove();
  }

  closeComments() {
    this.data.changeComments(false);
  }
}
